import React from 'react';
import cn from 'classnames';
import {
  StudioTemplate,
  TemplateElement,
  useChangeTemplateStudioMutation,
  useGetStudioQuery
} from '../../../../features/api/apiSlice';
import cameraTemplateImg from "../../../../components/Actions/img/camera-template.svg";
import desktopImg from "../../../../components/Actions/img/desktop.svg";
import styles from './Samples.module.css';

interface SamplesProps {
  isLoading: boolean;
  error: boolean;
  templates: StudioTemplate[];
}

const ELEMENT_TYPES = {
  CAMERA: "camera",
  SCREEN: "screen",
};

const Samples: React.FC<SamplesProps> = ({ isLoading, error, templates }) => {
  const { data: studio } = useGetStudioQuery();
  const [changeTemplate] = useChangeTemplateStudioMutation();
  const currentTemplateId = studio?.current_scene?.current_template?.id || null;

  const handleTemplateChange = (templateId: number) => {
    if (!studio?.current_scene) {
      return;
    }

    changeTemplate({ templateId }).catch(error =>
      console.error('Failed to change template:', error)
    );
  };

  if (isLoading) {
    return <p className={styles.samples__message}>Загрузка шаблонов...</p>;
  }

  if (error) {
    return <p className={styles.samples__message}>Ошибка при загрузке шаблонов.</p>;
  }

  if (!templates.length) {
    return <p className={styles.samples__message}>Нет доступных шаблонов</p>;
  }

  return (
    <div className={styles.samples}>
      {templates.map((template) => {
        const elements: TemplateElement[] = Array.isArray(template.elements)
          ? template.elements
          : [template.elements];

        return (
          <div
            key={template.id}
            className={cn(
              styles.samples__item,
              { [styles.samples__item_active]: currentTemplateId === template.id }
            )}
            onClick={() => handleTemplateChange(template.id)}
          >
            <h3 className={styles.samples__title}>{template.title}</h3>
            <div className={styles.samples__template}>
              <div className={styles["samples__elements-container"]}>
                {elements.map((element, index) => (
                  <div
                    key={index}
                    className={styles.samples__element}
                    style={{
                      top: element.top,
                      left: element.left,
                      width: element.width,
                      height: element.height,
                      zIndex: element.z_index,
                      display: element.display || "flex"
                    }}
                  >
                    <img
                      className={styles.samples__image}
                      src={element.type === ELEMENT_TYPES.CAMERA ? cameraTemplateImg : desktopImg}
                      alt={element.type === ELEMENT_TYPES.CAMERA ? "Camera" : "Screen"}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Samples;